module.exports = __webpack_public_path__ + "static/media/shiftshave-replacement-blade-2.3bc64953.jpg";